module.exports = __webpack_public_path__ + "img/wash.50855ddd.png";